import { render, staticRenderFns } from "./RiskLegenda2.vue?vue&type=template&id=88c61a8a&scoped=true&"
import script from "./RiskLegenda2.vue?vue&type=script&lang=js&"
export * from "./RiskLegenda2.vue?vue&type=script&lang=js&"
import style0 from "./RiskLegenda2.vue?vue&type=style&index=0&id=88c61a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c61a8a",
  null
  
)

export default component.exports